module.exports = __webpack_public_path__ + "img/notifi-info-blue.55790567.svg";